var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Randomizer = function () {
    function Randomizer(getRandomValuesFn) {
        _classCallCheck(this, Randomizer);

        this.getRandomValues = getRandomValuesFn;
    }

    _createClass(Randomizer, [{
        key: "randomByte",
        value: function randomByte() {
            return this.getRandomValues(new Uint8Array(1))[0];
        }
    }, {
        key: "randomWord",
        value: function randomWord() {
            return this.getRandomValues(new Uint16Array(1))[0];
        }
    }, {
        key: "randomDword",
        value: function randomDword() {
            return this.getRandomValues(new Uint32Array(1))[0];
        }

        /*
         * Generate an unbiased random number in the range [0, upperBound)
         */

    }, {
        key: "randomInteger",
        value: function randomInteger(upperBound) {
            if (!Number.isInteger(upperBound)) {
                throw TypeError("upperBound must be an integer");
            }
            if (upperBound < 2) {
                throw TypeError("upperBound must be above 2");
            }
            if (upperBound > 0x100000000) {
                throw TypeError("upperBound must be below or equal to 2^32");
            }

            var randomFn = this.randomDword;
            var rndRange = 0x100000000;
            if (upperBound <= 0x10000) {
                randomFn = this.randomWord;
                rndRange = 0x10000;
            } else if (upperBound <= 0x100) {
                randomFn = this.randomByte;
                rndRange = 0x100;
            }

            var remainder = rndRange % upperBound;
            while (true) {
                var rnd = randomFn.call(this);
                if (rnd >= remainder) {
                    return rnd % upperBound;
                }
            }
        }

        /*
         * return a random value from array
         */

    }, {
        key: "randomChoice",
        value: function randomChoice(array) {
            return array[this.randomInteger(array.length)];
        }
    }]);

    return Randomizer;
}();

export default Randomizer;
;


//////////////////
// WEBPACK FOOTER
// ./resources/js/lib/Randomizer.js
// module id = 58
// module chunks = 0